<template>
  <div class="zhezhao" @click="$emit('hideZhe')">
  </div>
</template>

<script>
export default {
  name: 'zhezhao'
}
</script>

<style>
.zhezhao{
  width:100%;
  height:100%;
  background:black;
  opacity:0.2;
  z-index:100;
  position:absolute;
  top:0;
  left:0;
}
</style>
